import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../contexts/AuthContext";
import { getSidebarParam } from "./Utils";
import Layout from "./Layout";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, ready } = useAuthContext();
  const location = useLocation();
  const [shouldDelayRedirect, setShouldDelayRedirect] = useState(false);
  // Check for sidebar parameter and set up delayed redirect if needed
  useEffect(() => {
    if (!ready || loading || isAuthenticated) {
      return;
    }

    const hasSidebarParam = getSidebarParam();

    if (hasSidebarParam) {
      setShouldDelayRedirect(true);

      const timer = setTimeout(() => {
        setShouldDelayRedirect(false);
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [ready, loading, isAuthenticated]);

  if (!ready || loading) return null;
  if (shouldDelayRedirect) return null;

  const storedTVUrl = localStorage.getItem("tvUrl");
  if (!storedTVUrl) {
    if (!isAuthenticated) {
      // Redirect to login if not authenticated
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
  } else if (!isAuthenticated && location.pathname !== storedTVUrl) {
    window.location.href = storedTVUrl;
  }

  // Render children with layout if authenticated
  console.log("[ProtectedRoute] Rendering children with layout");
  return <Layout>{children}</Layout>;
};

export default ProtectedRoute;
